import { useEffect, useState } from "react";
import { getPlanDetails } from "../../../services/rhapsody/RenewHealthCard";
import { HttpStatusCode } from "axios";
import { getRenewHealthCardPaymentUrl } from "../../../services/payment/payment";
import { capitalizeWords, updateThePlanNewName, getCurrentLocale } from "../../../utils/util";
import { Loader } from "../../../common/Loader";
import WarningInfo from "../../../common/WarningInfo";
import DirhamSymbol from "../../../common/DirhamSymbol";

const RenewHealthModal = ({
  show,
  close,
  data,
  setShowPaymentModal,
  translationMap,
  setIsPaymentProgress,
  cardNumber,
  isValidEid
}) => {
  const [planData, setPlanData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [coverageName, setCoverageName] = useState("");
  const [isProcessing, setIsProcessing] = useState(false); // Add processing state
  const [exceptionError, setExceptionError] = useState(false);
  const [errorHeading, setErrorHeading] = useState("");
  const [errorSubHeading, setErrorSubHeading] = useState("");
  const [locale, setLocale] = useState("");
  const isArabic = locale === "ar" || locale === "ar_SA";

  useEffect(() => {
    window.parent.scrollTo(0, 0);
    setLocale(getCurrentLocale());
    if (show && isValidEid) {
      setLoading(true);
      getPlanDetails(cardNumber)
      .then((res) => {
        if (res.status === HttpStatusCode.Ok) {
          setPlanData(res.data);
          if (res.data && res.data.payOrCode) {
            let name = updateThePlanNewName(res.data.payOrCode, res.data?.plan.name, translationMap);
            setCoverageName(name);
          }
          setError(null);
        } else {
          setError("Failed to load plan details");
          console.error(res.data);
        }
      })
      .catch((err) => {
        setError("An error occurred while fetching plan details");
        console.error(err);
      })
      .finally(() => setLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, isValidEid]);

  const handleProceedPayment = async () => {
    if (isProcessing) return; // Prevent multiple clicks

    setIsProcessing(true); // Set processing state to true

    setIsPaymentProgress(true);
    getRenewHealthCardPaymentUrl(cardNumber)
    .then((result) => {
      if (result.status === 200) {
        const url = result.data?.url;
        setShowPaymentModal(false);
        setIsPaymentProgress(false);
        setIsProcessing(false); // Reset processing state
        if (url) {
          window.parent.location.href = url;
        }
      } else {
        console.error("Failed to retrieve payment URL");
        setIsProcessing(false); // Reset processing state in case of failure
      }
    })
    .catch((error) => {
      const status = error.response?.status;
      const errorMsg = error.response?.data?.error;

      if (status === 400) {
        setExceptionError(true);
        setErrorHeading(translationMap?.checkSalama ?? "Check details on Salama");
        setErrorSubHeading(translationMap?.[errorMsg] ?? "please verify details");
      } else {
        setExceptionError(true);
        setErrorHeading(translationMap?.somethingWentWrongMesg ?? "Something went wrong. Please try again later.");
        setErrorSubHeading("");

      }
      setIsProcessing(false);
    });
    // .catch((err) => {
    //     console.error("Error during payment processing", err);
    //     setIsProcessing(false); // Reset processing state in case of failure
    // });
  };

  if (!show) return null;
  if (!isValidEid) return <>
        <div
      className="modal Custom_Modal_Box show"
      id="renewHealthmodal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
      style={{ display: "block" }}>
      
            <div className="modal-dialog CoveragePlan_Dialog1" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <div className="Title_Inner_Box">
                            <span className="material-symbols-outlined">radio_button_unchecked</span>
                            <h6 className="MainTitleOne">{translationMap?.coveragePlanRenewal}</h6>
                        </div>
                    </div>
                    <div className="modal-body">
                        <div className="Inner_Modal_Body">
                            <div className="AlertInnerBox YellowAlertInnerBox">
                                <div className="Icon_box">
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                    <a href="javascript:void(0);">
                                    <span className="material-symbols-outlined">
                                        warning
                                    </span>
                                    </a>
                                </div>
                                <div className="alert_text">
                                    <h6 className="MainTitleOne">{translationMap?.coveragePlanRenewal}</h6>

                                    <p className="number_txt">
                                        {translationMap?.eidMessageDesc}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer Renewal_Modal_Footer">
                        <button type="button" onClick={close} className="btn bluetrans_btn_link" data-dismiss="modal">
                            {translationMap?.close}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </>;
  return (
    <div
      className="modal Custom_Modal_Box show"
      id="renewHealthmodal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
      style={{ display: "block" }}>
      
            <div className="modal-dialog CoveragePlan_Dialog1" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <div className="Title_Inner_Box">
                            <span className="material-symbols-outlined">radio_button_unchecked</span>
                            <h6 className="MainTitleOne">{translationMap?.coveragePlanRenewal}</h6>
                        </div>
                    </div>
                    <div className="modal-body">
                        {exceptionError &&
            <WarningInfo
              setError={setExceptionError}
              alert_text={
              errorHeading
              }
              number_text={
              errorSubHeading
              } />

            }
                        {loading ?
            <Loader /> :
            error ?
            <div className="error-message">{error}</div> :
            planData?.isEligible ?
            <div className="Inner_Modal_Body">
                                <div className="Renewal_Free_box">
                                    <div className="box1">
                                        <h6>{translationMap?.renewalFee}</h6>
                                        <p>{coverageName}</p>
                                    </div>
                                    <div className="box2">
                                        <h6>
                                            <b>
                                              {isArabic ?
                                                <>{planData?.totalAmount}<DirhamSymbol width={12} height={12} marginTop={-1} /></> :
                                                <><DirhamSymbol width={12} height={12} marginTop={-1} />{planData?.totalAmount}</>
                                              }
                                            </b>
                                        </h6>
                                    </div>
                                </div>
                                <p className="para_txt">{translationMap?.text}</p>
                                <div className="Full_Name_Wrapper">
                                    <h6 className="MainTitleOne">{capitalizeWords(data.fullName)}</h6>
                                    <ul className="detail_box">
                                        <li>
                                            <p>
                                                <span>{translationMap?.mrn}</span>
                                                {data.mrn}
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                <span>{translationMap?.currentPlan}</span>
                                                {coverageName}
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                <span>{translationMap?.expiryDate}</span>
                                                {planData?.currentExpiryDate}
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                <span>{translationMap?.newPlan}</span>

                                                {coverageName || "N/A"}

                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                <span>{translationMap?.newExpiryDate}</span>
                                                {planData?.newExpiryDate || "N/A"}
                                            </p>
                                        </li>
                                    </ul>
                                </div>
                            </div> :
            <></>}
                    </div>
                    <div className="modal-footer Renewal_Modal_Footer">
                        <button
              onClick={close}
              type="button"
              className="btn bluetrans_btn_link"
              data-dismiss="modal">
              
                            {planData?.isEligible ? translationMap?.goBack : translationMap?.close}
                        </button>
                        {planData?.isEligible &&
            <button
              type="button"
              className="btn dubaipay_btn"
              onClick={handleProceedPayment}
              disabled={isProcessing}
              dir={isArabic ? "rtl" : "ltr"}>
              <span>{translationMap?.pay_with}</span>
              <svg viewBox="0 0 19.0605 14.2227" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" style={{ height: "1em", width: "auto", marginLeft: isArabic ? "8px" : "10px", marginRight: isArabic ? "10px" : "8px" }}>
                <path d="M17.3115 0C18.2759 0 19.0587 0.780805 19.0605 1.74512V12.4883C19.0508 13.4474 18.2707 14.2211 17.3115 14.2227H1.74512C0.786577 14.2209 0.0081499 13.4468 0 12.4883V1.74512C0.000174973 0.7814 0.781392 0.000184834 1.74512 0H17.3115ZM2.14844 12.0869H16.9268L16.9258 6.28516H2.13867L2.14844 12.0869ZM8.07031 8.20215C8.44096 8.04478 8.86978 8.12716 9.15625 8.41016C9.44276 8.69323 9.52995 9.12156 9.37695 9.49414C9.22389 9.86633 8.86143 10.1092 8.45898 10.1094C7.91509 10.1094 7.47233 9.67178 7.46582 9.12793C7.46116 8.72535 7.69973 8.35957 8.07031 8.20215ZM11.5283 8.12305C12.0766 8.12323 12.5214 8.56791 12.5215 9.11621C12.5215 9.6646 12.0767 10.1092 11.5283 10.1094C10.9798 10.1094 10.5352 9.66471 10.5352 9.11621C10.5353 8.5678 10.9799 8.12305 11.5283 8.12305ZM14.4062 8.12305C14.9547 8.12305 15.3993 8.5678 15.3994 9.11621C15.3994 9.66471 14.9548 10.1094 14.4062 10.1094C13.8585 10.1076 13.4147 9.66395 13.4131 9.11621C13.4132 8.56788 13.8579 8.12318 14.4062 8.12305ZM2.13477 4.1543H16.9248V2.13184H2.13184L2.13477 4.1543Z" fill={isProcessing ? "#5E5E62" : "white"}/>
              </svg>
              {isArabic
                ? <span>{translationMap?.pay}{" "}<strong>{translationMap?.dubai}</strong></span>
                : <span><strong>{translationMap?.dubai}</strong>{translationMap?.pay}</span>
              }
            </button>
            }
                    </div>
                </div>
            </div>
        </div>);

};

export default RenewHealthModal;